import React from 'react';

export const Footer = () => {
  const nowDate = new Date().getFullYear();

  return (
    <footer className='footer' id='contact'>
      <div className='footer__info'>
        <span>© {nowDate}</span> <a href='/'>Ruslan Kriklivyy</a>
      </div>
    </footer>
  );
};
